import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const PortalNewsPageObjClass = Scrivito.provideObjClass(
  "PortalNewsPage",
  {
    attributes: {
      ...defaultPageAttributes,
      body: "widgetlist",
      maxPostAgeInDays: "integer",
      isPrimary: "boolean"
    },
    onlyChildren: ["PortalNewsPost"],
    extractTextAttributes: ["description", "body"]
  }
)
export type PortalNewsPageObj = InstanceType<typeof PortalNewsPageObjClass>
